<template>
    <div class="dashboard">
        <iframe src="https://raw.githubusercontent.com/anars/blank-audio/master/250-milliseconds-of-silence.mp3" allow="autoplay" id="audio" style="display:none"></iframe>
        <side style="width:25%" :ranks="ranks"></side>
        <div class="content" style="width:75%">
            <top-c-v-header>
                <Marquee :marqueeList="news"></Marquee>
            </top-c-v-header>
            <div class="dash-row">
                <div class="first">
                    <shadow-box >
                        <calendar></calendar>
                    </shadow-box>
                </div>
                <div class="second">
                    <shadow-box :className="'bg-gra '">
                        <weather></weather>
                    </shadow-box>
                    <shadow-box>
                        <user-statistic :candidateNo="candidateNo" :employerNo="employerNo"></user-statistic>
                    </shadow-box>
                </div>
            </div>
                
            <div class="dash-row">
                <div class="first">
                    <shadow-box >
                        <birthday v-if="birthdays.length != 0" :birthdays="birthdays"></birthday>
                        <quote :quote="quote" v-else ></quote>
                    </shadow-box>
                </div>

                <div class="second">
                    <shadow-box class="">
                        <check-in ></check-in>
                    </shadow-box>
                </div>
                
            </div>
        </div>
        
        <modal  :width="'80%'" :classes="'modal-congratulation'" name="modal-payment-completed">
            <div class="front-img">

            </div>
            <div class="back-img" :style="{backgroundImage:'url('+modal.useravatar+')'}">

            </div>
            <div class="text-img">
                <p class="text-uppercase text-big">Chúc mừng</p>
                <p class="text-medium">hoàn thành hợp đồng với khách hàng {{ modal.customer }}</p>
                <p class="text-big">{{ modal.money | toCurrency }}</p>
            </div>
            <div class="text-name">{{ modal.user }}</div>
        </modal>

        <modal  :width="'80%'" :height="'80%'"  name="modal-wake-up" class="modal-wake-up">
            <div >
                <!-- <iframe src="https://www.nhaccuatui.com/mh/background/ir71rb8MT5ki" width="1" height="1" frameborder="0" allowfullscreen allow="autoplay"></iframe> -->
                <youtube-media :player-width="'100%'" :player-height="'750px'" :player-vars="{ start: 0, autoplay: 1 }" :video-id="youtube_id"></youtube-media>
            </div>
        </modal>

        <modal  :width="'80%'" name="modal-start-up">
            <div class="modal-start-up">
                <button @click="start()" class="btn btn-success">Bắt đầu sử dụng TOPCV DASHBOARD</button>
            </div>
        </modal>

        <modal  :width="'80%'" :height="'80%'" name="modal-birthday">
            <div class="modal-birthday">
                 <swiper :options="swiperOption">
                   
                        <swiper-slide :key="index" v-for="(birthday,index) in birthdays">
                            <div class="birthday-item">
                                 <div class="birthday-name">
                                    {{ birthday.name }}
                                </div>
                                <div class="birthday-avatar">
                                    <img :src="birthday.image" alt="">
                                    <div class="banner">

                                    </div>
                                </div>
                                <div class="birthday-date">
                                    {{ birthday.dob.date | toVNDate }} <br>
                                    {{ today }}
                                </div>
                                
                            </div>
                        </swiper-slide>
                </swiper>
                
            </div>
        </modal>
    </div>
</template>
<script>
import Calendar from '@/components/Calendar'
import Weather from '@/components/Weather'
import UserStatistic from '@/components/UserStatistic'
import Birthday from '@/components/Birthday'
import CheckIn from '@/components/CheckIn'
import Side from '@/components/Side'
import TopCVHeader from '@/components/TopCVHeader'
import ShadowBox from '@/components/ShadowBox'
import Marquee from '@/components/Marquee'
import moment from 'moment';
import Quote from '@/components/Quote.vue';
import Slick from 'vue-slick';
import { Carousel, CarouselItem } from 'vue-l-carousel'
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import { getIdFromURL, getTimeFromURL } from 'vue-youtube-embed'
var notiAudio = new Audio(require('@/assets/noti.mp3'))
var birthdayAudio = new Audio(require('@/assets/hpbd.mp3'))
var bravoAudio = new Audio(require('@/assets/bravo.mp3'))
var startAudio = new Audio(require('@/assets/start.mp3'))



import {getNewsApi, getQrApi,getBirthdayApi,getUserStatisticApi, getRankingApi, getVoiceUrlApi, getWakeUpSongApi} from '@/api/api'
export default {
  name: 'Dashboard',
  components: {Marquee, swiper, swiperSlide, Calendar, Weather, UserStatistic, Birthday, CheckIn, Side,TopCVHeader, ShadowBox, Quote, Slick,Carousel,CarouselItem},
  data () {
    return {
        swiperOption: {
          autoplay: {
            delay: 3000,
          },
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev'
          }
        },
        news:[],
        birthdayDuration:0,
        modalQueue:[],
        secondModalQueue:[],
        speaking:false,
        employerNo: 10000,
        candidateNo: 80000,
        birthdays:[],
        ranks:[],
        quote:'Bắt đầu từ nơi bạn đứng. Sử dụng những gì bạn có. Làm những gì bạn có thể',
        modal:{
            user: 'Nhân viên TOPCV',
            customer: 'Khách hàng TOPCV',
            money:"5.000.000 đ",
            useravatar: 'https://work.topcv.vn/images/noavatar.png',
            voice: '',
            name:'modal-x',
            time_display:0
        },
        youtube_url: 'https://www.youtube.com/watch?v=NIJHqNWMtAw',
        youtube_play_time: 300000
    }
    
  },
  computed: {
        today() {
            return moment().format('DD/MM/YYYY');
        },

        youtube_id () {
            return getIdFromURL(this.youtube_url)
        },
        
        youtube_time () {
            return getTimeFromURL(this.youtube_url)
        }
  },
  watch: {
      modalQueue(newValue, oldValue) {
        //   console.log(newValue.shift());
        if (this.modalQueue.length != 0) {
            notiAudio.play();
            this.modal = this.modalQueue[0];
            this.speaking = true;

            if (this.modal.name == 'modal-birthday') {
                this.playBirthdaySong();
                this.modal.time_display = this.birthdayDuration*1000 + 5000;
            } else if (this.modal.name == 'modal-payment-completed') {
                this.getRanking();
                getVoiceUrlApi(this.modal.voice).done((rs)=>{
                    var audio = new Audio(rs.data);
                    audio.addEventListener('loadeddata', () => {
                        let duration = audio.duration;
                        audio.play();
                        setTimeout(()=>{
                            bravoAudio.play();

                        },duration*1000);
                    
                    })
                    this.$modal.show(this.modal.name);
                });
                
            } else {
                this.$modal.show(this.modal.name);

            }
            setTimeout(()=>{
                this.$modal.hide(this.modal.name);
                this.modalQueue.shift();
                this.speaking = false;
                this.modalQueue = this.modalQueue.concat(this.secondModalQueue);
                this.secondModalQueue = [];
            }, this.modal.time_display);
        }
      }
  },
  methods: {
    start(){
        startAudio.play();
        this.$modal.hide('modal-start-up');
    },
    getBirthday(){
      getBirthdayApi().done((rs)=>{
        this.birthdays = rs.data.haveBirthdayUsers; 
      });
    },
    getUserStatistic(){
      getUserStatisticApi().done((rs)=>{
        this.candidateNo = rs.data.candidate_count; 
        this.employerNo = rs.data.employer_count; 
      });
    },

    getNews(){
        getNewsApi().done((rs) => {
            this.news = rs.data;
        })
    },

    getWakeUpSong(){
        getWakeUpSongApi().done((rs)=>{
            this.youtube_url = rs.data.youtube_url;
            this.youtube_play_time = rs.data.youtube_play_time;
        })
    },

    getRanking(){
      getRankingApi().done((rs)=>{
        this.ranks = rs.data;
      });
    },
    fullscreen(){
        var elem = document.documentElement;
        elem.webkitRequestFullscreen();
    },
    playBirthdaySong(){
        // birthdayAudio.play();
        notiAudio.play();
        var name = '';
        this.birthdays.forEach((birthday)=>{
            name+= birthday.name + ',';
        });

        getVoiceUrlApi("Chúc mừng sinh nhật bạn " + name).done((rs)=>{
            var audio = new Audio(rs.data);
            audio.addEventListener('loadeddata', () => {
                let duration = audio.duration;
                audio.play();
                this.$modal.show('modal-birthday');
                setTimeout(()=>{
                    birthdayAudio.play();

                },duration*1000);

                setTimeout(() => {
                    this.$modal.hide('modal-birthday');

                },this.birthdayDuration*1000);
            
            })
            
            
        });
    },
    playWakeUpSong() {

            var modal = {
                name:'modal-wake-up',
                time_display: this.youtube_play_time
            };

            if (this.speaking) {
                this.secondModalQueue.push(modal);
            } else {
                this.modalQueue.push(modal);
            }

    }
  },
  mounted () {
        this.getNews();
        // this.$modal.show('modal-start-up');
        // setTimeout(() => {
        //     this.$modal.hide('modal-start-up');
        // }, 5000)
        this.getBirthday();
        this.getUserStatistic();
        this.getRanking();
        this.getWakeUpSong();
        this.$root.$on('at-9AM', (text) => {
            if (this.birthdays.length > 0) {
                var modal = {
                    name:'modal-birthday',
                };

                if (this.speaking) {
                    this.secondModalQueue.push(modal);
                } else {
                    this.modalQueue.push(modal);
                }
            }
        })

        this.$root.$on('at-1AM', (text) => {
            this.getNews();
            this.getWakeUpSong();
            this.getBirthday();
            this.getUserStatistic();
            this.getRanking();
        })

        this.$root.$on('at-1PM', (text) => {
            this.playWakeUpSong();
        })

    },
  created(){
        // setInterval(()=>{
        //     this.$root.$emit('at-1PM');
        // }, 10000);
        birthdayAudio.addEventListener('loadeddata', () => {
            this.birthdayDuration = birthdayAudio.duration + 5;
        })

        var channel = this.$pusher.subscribe('dashboard');
        channel.bind('payment-completed', ( log ) => {
            if (this.speaking) {
                this.secondModalQueue.push(log);
            } else {
                this.modalQueue.push(log);
            }
            
        });
  }
}
</script>
<style lang="scss">
.text-medium{
    font-size: 1.3em;
}
.dashboard{
    display: flex;
}
.content{
    width: 100%;
}
.dash-row{
    display: flex;
}
.first{
    width: 40%;
}

.second{
    width: 60%;
}
.text-big{
    font-size: 40px;
    font-weight: bold;
}

.modal-congratulation{
    position: relative;
    top: 5%!important;
    min-height: 90%;
    background: #fff;
    border-radius: 30px!important;
    
    .front-img{
        z-index: 9999999;
        background: url('../assets/sale1.png');
        background-size: 100% 100%;
        position: absolute;
        width: 100%;
        height: 100%;
    }
    .back-img{
        z-index: 9999;
        background-size: 100% 100%;
        position: absolute;
        width: 60%;
        height: 100%;
    }
    .text-img{
        text-align: center;
        color:#fff;
        right: 5%;
        top: 40%;
        z-index: 999999999;
        position: absolute;
        

    }
    .text-name{
        background: #b8b8b8;
        padding: 0.5em;
        text-shadow: 4px 3px 0 #7A7A7A;
        color: #FFFFFF;
        position: absolute;
        bottom: 10%;
        color: #fff;
        font-size: 2em;
        z-index: 9999999999999;
        left: 20%;;
        font-weight: bold;
        text-transform: uppercase;
    }

}

.modal-birthday{
   
    background: url(../assets/birthday1.png);
    width: 100%;
    height: 100%;
    background-size: cover;
    .birthday-item{
        margin-top: 2em;
        display: flex;
        justify-content: space-around;
        .birthday-name, .birthday-date{
            padding-top: 3em;
            color: #2B5F6F;
            font-size: 3em;
            font-weight: bold;
        }
        .birthday-avatar{
            position: relative;
            // overflow: hidden;
            width: 400px;
            height: 400px;
            border-radius: 50%;
            img{
                width: 100%;
                width: 400px;
                height: 400px;
                border-radius: 50%;
                border:solid 20px #FFDB48;
            }
            .banner{

                background: url(../assets/birthday2.png) no-repeat;
                background-size: 100%;
                width: 100%;
                position: absolute;
                bottom: 5%;
                height: 100px;;
            }
        }
        
    }
}
.label{
    margin: 0 10px;
    padding: 3px;
    border-radius: 5px;
    border:solid 1px;
}

.label-success {
    background: #27ae60;
    color: #fff;
    font-weight: bold;
}
.modal-start-up{
    padding: 3em;
    text-align: center;
}
.modal-wake-up{
    text-align: center;
    height: 90%;
}
</style>





// WEBPACK FOOTER //
// src/components/Home.vue